/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TimerRelativeType {
    BEFORE = 'before',
    AFTER = 'after',
}
